import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import Chip from '../ui/Chip'
import Select from '../ui/Select/Select'

const CONTROL_BORDER_COLOR = '#d1d5db'
const CONTROL_BORDER_COLOR_ERROR = '#f05252'
const CONTROL_MIN_HEIGHT = 36
const INPUT_ID = 'parallel-status'

const STATUS_OPTIONS = [
  { value: 'open', label: 'Brouillon', variant: 'warning' },
  { value: 'closed', label: 'Terminé', variant: 'success' },
  { value: 'disabled', label: 'Non applicable', variant: 'neutral' }
]

const formatOptionLabel = option => <Chip variant={option.variant}>{option.label}</Chip>

const ParallelStatusSelect = ({ value, disabledStatusAvailable, statusError, onChange }) => {
  const options = useMemo(() => STATUS_OPTIONS.filter(
    option => disabledStatusAvailable || option.value !== 'disabled'
  ), [disabledStatusAvailable])
  const selected = options.find(option => option.value === value) || null
  const handleChange = useCallback(option => onChange(option.value), [onChange])
  const errorMessage = statusError.join(', ')

  return (
    <div>
      <div className="tw:flex! tw:items-center tw:gap-1">
        <label className="tw:m-0! tw:text-sm tw:font-normal tw:text-gray-900" htmlFor={INPUT_ID}>
          Statut actuel :
        </label>
        <Select
          className="tw:w-47"
          controlBorderColor={statusError.length ? CONTROL_BORDER_COLOR_ERROR : CONTROL_BORDER_COLOR}
          controlMinHeight={CONTROL_MIN_HEIGHT}
          formatOptionLabel={formatOptionLabel}
          inputId={INPUT_ID}
          isSearchable={false}
          menuPlacement="top"
          options={options}
          value={selected}
          onChange={handleChange}
        />
      </div>
      {errorMessage ? <div className="text-danger small tw:mt-1">{errorMessage}</div> : null}
    </div>
  )
}

ParallelStatusSelect.propTypes = {
  disabledStatusAvailable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  statusError: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.oneOf(['open', 'closed', 'disabled']).isRequired
}

ParallelStatusSelect.defaultProps = {
  disabledStatusAvailable: false,
  statusError: []
}

export default ParallelStatusSelect
